import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=2f8259a4&scoped=true&"
import script from "./Contact.js?vue&type=script&lang=js&"
export * from "./Contact.js?vue&type=script&lang=js&"
import style0 from "./Contact.css?vue&type=style&index=0&id=2f8259a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8259a4",
  null
  
)

export default component.exports